export { array } from './array.js';
export { object } from './object.js';
export { regexp } from './regexp.js';
